import {useCallback, useEffect, useState} from "react";
import {fetch} from "utils/dataAccess";

const POLL_INTERVAL_MS = 5000;

export default function useBatchActions() {

    const [runningActions, setRunningActions] = useState([]);

    const refreshRunningActions = useCallback(() => {
        fetch("/batch_actions?pagination=false&status=running").then(
            response => {
                response.json().then(retrieved => {
                    setRunningActions(retrieved['hydra:member']);
                });
            }
        );
    }, []);

    useEffect(() => {
        refreshRunningActions();
    }, [refreshRunningActions]);

    // keep the progress counters moving while at least one action runs; the
    // Pusher completion event does the final refresh, this is what animates
    // the percentage in between
    useEffect(() => {
        if (0 === runningActions.length) {
            return;
        }

        const interval = setInterval(refreshRunningActions, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [runningActions.length, refreshRunningActions]);

    return {
        runningActions,
        refreshRunningActions
    };
}
